<template>
  <Card>
    <template slot="header"> Check In </template>
    <Scan/>
    <Reservations/>
  </card>
</template>

<script>
import Scan from '@/components/checkin/Scan'
import Reservations from '@/components/checkin/Reservations'
export default {
  components: {
    Scan,
    Reservations
  }
}
</script>
